// resultUi/SpotItems.js
export class SpotItems {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;
    this.store = app.store;
    this.wayTable = this.store.config.wayTable;
  }

  getTags() {
    // ★ mixInfo が undefined の瞬間でも絶対に落ちないようにする
    const mixInfo = this.app.getState('mixInfo');
    const infos = mixInfo?.plan_infos || []; // ← ここが最重要

    // 何もなければ空文字で返す
    if (!infos.length) {
      return '';
    }

    let tags = '';

    infos.forEach((info, i) => {
      switch (i) {
        case 0:
          tags += this.getStartItemTags(info);
          break;

        case infos.length - 1:
          tags += this.getEndItemTags(info);
          break;

        default:
          tags += this.getNormalItemTags(info, i);
          break;
      }
    });

    return tags;
  }

  getStartItemTags(info) {
    let tags = '';
    tags += `
    <section class="section-start flex items-start gap-8 relative before:content-[''] before:w-[1px] before:block before:bg-primary5 before:h-full before:top-0 before:bottom-0 before:absolute md:before:left-[39px] before:left-[23px] before:z-1 pb-5">
        <div class="border-primary5 border bg-white w-[48px] h-[48px] md:w-[80px] md:h-[80px] flex justify-center items-center rounded-sm serif relative z-2">
          <p class="text-primary5 md:text-lg text-xs">START</p>
        </div>
        <div class="w-full flex-1">
          <h2 class="text-xl font-bold serif">${info.title}</h2>
        </div>
      </section>

      <div class="flex gap-14 relative before:content-[''] before:w-[1px] before:block before:bg-primary5 before:h-full before:top-0 before:bottom-0 before:absolute md:before:left-[39px] before:left-[23px] before:z-1 py-5 items-center md:pl-[19px] pl-[9px]">
        <div class="border-primary5 border bg-white md:w-[40px] md:h-[40px] w-[32px] h-[32px] flex justify-center items-center rounded-sm serif relative z-2 text-primary5 md:p-2 p-1">
            ${this.wayTable[info.route_info.way].nameByFa}
        </div>
        <div class="flex-1 before:content-[''] before:w-[40px] before:h-[1px] before:border-t-2 before:border-primary5 before:border-dotted relative before:absolute before:-left-[60px] before:top-[10px]">
          <p class="serif">${this.app.I18n('about')}${info.route_info.time}${this.app.I18n('minute')}</p>
        </div>
      </div> `;
    return tags;
  }

  getNormalItemTags(info, index) {
    let tags = '';
    tags += `<section class="section-start flex items-start gap-8 relative before:content-[''] before:w-[1px] before:block before:bg-primary5 before:h-full before:top-0 before:bottom-0 before:absolute md:before:left-[39px] before:left-[23px] before:z-1 pb-5" id="disp_spot${index}">
              <div class="bg-primary5 w-[48px] h-[48px] md:w-[80px] md:h-[80px] flex justify-center items-center rounded-sm relative z-2">
                <p class="text-white text-lg">${index}</p>
              </div>
              <div class="loop_spot_gocha flex-1">
                <h2 class="text-xl font-bold serif">${info.title}</h2>
                <p class="text-sm mb-1 border-t border-[#917208] text-[#917208] mt-1 pt-1">${info.arrival_time}〜${info.departure_time} (${info.stay_time}${this.app.I18n('minute')})</p>
                <div class="bg-white md:flex gap-10 md:p-10 p-5 justify-between mt-3">
                  <div class="aspect-3/2 bg-black1 md:w-[50%] w-full">
                    <img src="${info.pic_path}" alt="${info.title}" class="h-full w-full object-contain" loading="lazy">
                  </div>
                  <div class="flex-1">
                    <p>${info.description}</p>
                    <a href="${info.permalink}" target="_blank" class="border-black2 border rounded-lg bg-white flex justify-center py-4 px-10 items-center gap-2 relative max-w-[280px] hover:opacity-50 transition duration-300 font-bold m-auto mt-8">
                      <span class="text-primary5 serif">${this.app.I18n('detailView')}</span>
                      <span class="absolute text-primary5 right-[24px] w-[8px]">
                        <svg viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                          <path d="M1.33372 0.333172L0.15039 1.5165L5.63372 6.99984L0.150391 12.4832L1.33372 13.6665L8.00039 6.99984L1.33372 0.333172Z"></path>
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            <div class="flex gap-14 relative before:content-[''] before:w-[1px] before:block before:bg-primary5 before:h-full before:top-0 before:bottom-0 before:absolute md:before:left-[39px] before:left-[23px] before:z-1 py-5 items-center md:pl-[19px] pl-[9px]">
              <div class="border-primary5 border bg-white md:w-[40px] md:h-[40px] w-[32px] h-[32px] flex justify-center items-center rounded-sm serif relative z-2 text-primary5 md:p-2 p-1">
                ${this.wayTable[info.route_info.way].nameByFa}
              </div>
              <div class="flex-1 before:content-[''] before:w-[40px] before:h-[1px] before:border-t-2 before:border-primary5 before:border-dotted relative before:absolute before:-left-[60px] md:before:top-[10px] before:top-[50%]">
                <p class="serif">${this.app.I18n('about')}${info.route_info.time}${this.app.I18n('minute')}</p>
              </div>
            </div>`;
    return tags;
  }

  getEndItemTags(info) {
    let tags = '';
    tags += `<section class="section-start flex items-start gap-8 relative pb-5">
              <div class="border-primary5 border bg-white w-[48px] h-[48px] md:w-[80px] md:h-[80px] flex justify-center items-center rounded-sm serif relative z-2">
                <p class="text-primary5 md:text-lg text-xs">GOAL</p>
              </div>
              <div class="loop_spot_gocha flex-1">
                <h2 class="text-xl font-bold serif">${info.title}</h2>
                <p class="text-sm mb-1 border-t border-[#917208] text-[#917208] mt-1 pt-1">${info.arrival_time}〜${info.departure_time} (${info.stay_time}${this.app.I18n('minute')})</p>
                <div class="bg-white md:flex gap-10 md:p-10 p-5 justify-between mt-3">
                  <div class="aspect-3/2 bg-black1 md:w-[50%] w-full">
                    <img src="${info.pic_path}" alt="${info.title}" class="h-full w-full object-contain" loading="lazy">
                  </div>
                  <div class="flex-1">
                    <p>${info.description}</p>
                    <a href="${info.permalink}" target="_blank" class="border-black2 border rounded-lg bg-white flex justify-center py-4 px-10 items-center gap-2 relative max-w-[280px] hover:opacity-50 transition duration-300 font-bold m-auto mt-8">
                      <span class="text-primary5 serif">${this.app.I18n('detailView')}</span>
                      <span class="absolute text-primary5 right-[24px] w-[8px]">
                        <svg viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                          <path d="M1.33372 0.333172L0.15039 1.5165L5.63372 6.99984L0.150391 12.4832L1.33372 13.6665L8.00039 6.99984L1.33372 0.333172Z"></path>
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </section>`;
    return tags;
  }

  render() {
    this.node.innerHTML = '';

    const isFetching = this.app.getState('isFetching');
    const hasData = this.app.getState('hasValidSpotData') === true;

    // fetch終了かつ有効なスポット情報があれば
    if (!isFetching && hasData) {
      this.node.innerHTML = this.getTags();
    }
  }
}
